export default "__VITE_ASSET__BS91R9Qk__"